module.exports = __webpack_public_path__ + "img/jp-logo.e21fbc27.png";